import axios from "axios";

const instance = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
});

// ✅ REQUEST INTERCEPTOR (API KEY)
instance.interceptors.request.use(
  (config) => {

    config.headers["x-api-key"] =
      process.env.REACT_APP_API_KEY;

    const token =
      localStorage.getItem("token");

    if (token) {
      config.headers.Authorization =
        `Bearer ${token}`;
    }

    console.log(
      "TOKEN =>",
      token
    );

    return config;
  },
  (error) => Promise.reject(error)
);

// ✅ RESPONSE INTERCEPTOR (simple)
instance.interceptors.response.use(
  (response) => {
    if (!response.data) response.data = {};
    if (!response.data.data) response.data.data = [];
    return response;
  },
  (error) => {
    console.log("API ERROR:", error?.response?.data || error.message);
    return Promise.reject(error);
  }
);

export default instance;